import * as React from 'react';
import * as TerminalInstallationModule from 'Modules/TerminalInstallationModule';
import {connect} from 'react-redux';
import * as Dictionary from 'Models/Dictionary';
import {withTranslation} from 'react-i18next';
import moment from 'moment';
import {createSerachQuery} from 'Connectors/_main';
import {RootState} from 'Redux/Reducers/_RootReducer';
import {EnumTypes as TerminalInstallationEnumTypes} from 'Models/EnumTypes/TerminalInstallationEnumTypes';
import {
    injectThProps,
    checkPageQuery,
    Cell,
    Filter,
    TerminalInstallationListBlock,
    IReactTableWrapper
} from 'HelperFunctions/Lists';
import {TerminalInstallationSelectors} from 'Redux/Selectors/TerminalInstallationSelectors';
import {InfinityReactTable, InfinityScrollParams, Footer} from "components/common/InfinityReactTable"

import * as ErrorActions from "Redux/Actions/ErrorActions";
import {EnumTypes as ErrorEnumType} from "Models/EnumTypes/ErrorEnumTypes";
import i18n from "Translations/_i18n";
import * as InfinityTableModule from "Modules/InfinityTableModule";
import * as ContractModule from "Modules/ContractModule";
import * as VehiclesModule from "Modules/VehiclesModule";
import * as UserModule from "Modules/UserModule";
import {TerminalInstalationStatusIcon} from "Models/Dictionary";

type ConnectedDispatch = {
    getTerminalInstallationOrders: (queryParams?: URLSearchParams, filterQuery?: boolean) => Function;
    getTerminalInstallationOrderHistory: (index: number) => Function;
    setActive: (id: number) => Function;
    setTerminalInstallationOrderHistoryList: (list: Array<any>) => Function;
    setStatusHistoryLoader: (status: TerminalInstallationModule.TerminalInstallationEnumTypes.HistoryRequestStatus) => Function;
    copiedToClipboard: (text) => Function;
    addNote: (index: number, note: string) => Function;
    getTerminalNotes: (index: number) => Function;
    t?: Function;
    setInfinityTableLoading: Function;
    setCurrentContractVin: Function;
};

type ConnectedProps = {
    terminalInstallationOrderList: Array<TerminalInstallationModule.Types.TerminalInstallationOrderSimpleDto>;
    terminalInstallationTotalCount: number;
    terminalInstallationOrderActive: number;
    terminalInstallationOrderHistoryList: Array<TerminalInstallationModule.Types.TerminalInstallationOrderHistory>
    terminalInstallationNotesList: Array<TerminalInstallationModule.Types.TerminalInstallationNote>
    historyLoader: TerminalInstallationModule.TerminalInstallationEnumTypes.HistoryRequestStatus,
    historyComment: TerminalInstallationModule.Types.TerminalInstallationOrderDto,
    selectedContractElementId: number,
    selectedContractVin: string,
};

type S = {
    selected: number;
    activeSorting: string;
    activeFilters: Array<{ id: string, value: any }>;
    expanded: any;
};

class TerminalInstallationList extends React.PureComponent<ConnectedProps & ConnectedDispatch, S> implements IReactTableWrapper {
    constructor(props: ConnectedProps & ConnectedDispatch) {
        super(props);
        this.state = {
            selected: this.props.selectedContractElementId || null,
            activeSorting: '',
            activeFilters: [],
            expanded: {}
        };

        this.unmountExpandedCallBack = this.unmountExpandedCallBack.bind(this);
        this.handleRowExpanded = this.handleRowExpanded.bind(this);
        this.setActiveSorting = this.setActiveSorting.bind(this);
        this.getTerminalInstallation = this.getTerminalInstallation.bind(this);

        this.infinityScrollParams = new InfinityScrollParams(35);
        this.infinityScrollParams.setWaypointRef(React.createRef());
        this.getTrProps = this.getTrProps.bind(this);
    }

    private noOrderFilter = Filter.InputTextFilter.bind(this, this.props.t('noOrder'), true);
    private noSellerProposalFilter = Filter.InputTextFilter.bind(this, this.props.t('noSellerProposal'), true);
    private carManufacturerOrModelFilter = Filter.InputTextFilter.bind(this, this.props.t('carManufacturerOrModel'), true);
    private addressFilter = Filter.InputTextFilter.bind(this, this.props.t('address'), true);
    // private vinFilter = Filter.InputTextFilter.bind(this, this.props.t('VIN'));
    private vinFilter = Filter.InputTextWithDefaultValue.bind(this, this.props.t('VIN'), this.props.selectedContractVin || '');
    private technicianFilter = Filter.InputTextFilter.bind(this, this.props.t('technician'), true);
    private orderReceivalDateFilter = Filter.SortFilter.bind(this, this.props.t('createDate'));
    private plannedInstallationDateFilter = Filter.SortFilter.bind(this, this.props.t('plannedInstallationDate'));
    private installationDateFilter = Filter.SortFilter.bind(this, this.props.t('installationDate'));
    private statusFilter = Filter.TooltipFilter.bind(this, this.props.t('orderStatus'));
    private infinityScrollParams: InfinityScrollParams;

    private statusCell = props => {
        const original: TerminalInstallationModule.Types.TerminalInstallationOrderDto = props.original;
        return (
            <span title={this.props.t(`dictionary:${props.value}`)} className="flex flex--center cell__status">
                <img src={Dictionary.TerminalInstalationStatusIcon.get(props.value)} alt=""
                     className="mr-7 cell__status-icon"/>
                {
                    (original && (original.carHasDamage || original.compatibleVin === false || original.dashboardHasErrors || original.commentOnCarDamage)) ?
                        <span className="cell__status-dot"/> : ""
                }
                <span>{this.props.t(`dictionary:${props.value}`)}</span>
            </span>
        )
    }

    private getTrProps = (state, rowInfo: { original: TerminalInstallationModule.Types.TerminalInstallationOrderDto; [name: string]: any }, column) => {
        const trClass = rowInfo && rowInfo.index === this.state.selected ? 'active' : '';
        return {
            onClick: () => {
                this.setState({selected: rowInfo.index});
                this.props.setActive(rowInfo.original.id);
            },
            className: trClass
        };
    }

    private checkPageQueryLocal(tableFiltered: Array<{ id: string; value: any }>, statePage: any, itemsPerLoad: number, itemsFirstLoad: number) {
        const tempFiltered = tableFiltered || [];
        return checkPageQuery(tempFiltered, statePage, itemsPerLoad, itemsFirstLoad);
    }

    private async getTerminalInstallation(tableState: any, scrollLoad: boolean = false, firstLoadCount: number = null) {
        /*
         * Pierwsze woła onFetchData (scrollLoad = false)
         * Zawsze gdy woła onFetchData to resetuje wskazniki infinityScrolla bo to beda filtry i sortowanie
         * Kiedy infinity scroll się ładuje (scrollLoad = true) to currentPage sie zwieksza, a parametr state jest nullem.
         */

        if (scrollLoad && this.props.terminalInstallationOrderList.length >= this.props.terminalInstallationTotalCount) {
            return 0;
        }

        const {activeFilters, currentPage, itemsPerLoad, itemsFirstLoad} = this.infinityScrollParams.prepareLoadParams(tableState, scrollLoad);

        // Jeśli w wywołaniu metody będzie przekazana wartość tzn. że dynamicznie była liczona ilość wierszy do pierwszego ładowania.
        // Wykonane ze względu na potrzebę sterowania tym w sytuacji np.
        const newItemsFirstLoad = firstLoadCount || itemsFirstLoad;
        this.props.setInfinityTableLoading(true);

        // odwrócenie domyślnego sortowania przy filtrowaniu tylko na polu orderNumber
        if (activeFilters.length === 1 && activeFilters[0].id === 'orderNumber') {
            activeFilters.push({id: 'sort_orderNumber', value: 'ASCENDING'});
        }

        //***** Naprawa błędnego filtrowania razem z sortowaniem
        Filter.FilterSortingFix.call(this, activeFilters);
        //******

        // żeby nie wysłać przypadkiem jakiegoś pustego filtra tylko jak ma jakieś value przypisane
        const activeFiltersPrepared = activeFilters.filter(element => element.value);

        // jeśli jest zaznaczona umowa w tabeli umów to filtruje po vinie pojazdu z tamtej umowy
        if (this.props.selectedContractVin) {
            activeFiltersPrepared.push({id: 'vin', value: this.props.selectedContractVin});
            this.props.setCurrentContractVin(null);
        }

        const query = this.checkPageQueryLocal(
            activeFiltersPrepared,
            currentPage,
            itemsPerLoad,
            newItemsFirstLoad
        );
        const params = createSerachQuery(query);

        this.props.setActive(null);

        await this.props.getTerminalInstallationOrders(params, !scrollLoad);

        this.props.setInfinityTableLoading(false);

        this.setState({
            selected: null,
            activeFilters: activeFiltersPrepared,
            expanded: {}
        });
    }

    private async handleRowExpanded(newExpanded, index, event) {
        if (!this.state.expanded[index]) {
            this.props.getTerminalInstallationOrderHistory(index);
            this.props.getTerminalNotes(this.props.terminalInstallationOrderActive);
            this.setState({expanded: {[index]: true}});
        } else {
            this.setState({expanded: {[index]: false}});
        }
    };

    private unmountExpandedCallBack() {
        this.props.setTerminalInstallationOrderHistoryList([]);
        this.props.setStatusHistoryLoader(TerminalInstallationEnumTypes.HistoryRequestStatus.SHOW)
    }

    public setActiveSorting(e: any, colId: string, onChange: Function) {
        this.setState({
                activeSorting: colId
            }, () => onChange(e)
        );
    }

    private cutDataTextCall = (props, callback) => {
        const dateString = (props.value) ? moment(props.value).format('HH:mm, DD.MM.YYYY') : '-';
        return Cell.CutTextCell({value: dateString}, callback)
    }

    public render() {
        const {terminalInstallationOrderList} = this.props;
        const {t} = this.props;

        return (
            <>
                <div className="table__content" ref={this.infinityScrollParams.getWaypointRef()}
                     data-testid="terminal-installation-table">
                    <InfinityReactTable
                        data={terminalInstallationOrderList}
                        columns={this.columns}
                        onFetchData={this.getTerminalInstallation}
                        filterable={true}
                        resizable={true}

                        getTheadThProps={injectThProps}

                        waypointRef={this.infinityScrollParams.getWaypointRef()}

                        loadingText={t(`tables:${'loading'}`)}
                        pageText={t(`tables:${'pageText'}`)}
                        nextText={t(`tables:${'nextText'}`)}
                        previousText={t(`tables:${'previousText'}`)}
                        rowsText={t(`tables:${'rowsText'}`)}
                        noDataText={t(`tables:${'noDataText'}`)}
                        getTrProps={this.getTrProps}

                        defaultPageSize={this.infinityScrollParams.getItemsFirstLoad()}

                        onExpandedChange={this.handleRowExpanded}
                        expanded={this.state.expanded}

                        SubComponent={() => <TerminalInstallationListBlock
                            terminalInstallationLogs={this.props.terminalInstallationOrderHistoryList}
                            terminalInstallationNotes={this.props.terminalInstallationNotesList}
                            historyComment={this.props.historyComment}
                            unmountCallBack={this.unmountExpandedCallBack}
                            loader={this.props.historyLoader}
                            addNote={this.props.addNote}
                            terminalId={this.props.terminalInstallationOrderActive}
                        />}
                        activeId={this.state.selected}
                    />
                </div>

                <Footer/>
            </>
        );
    }

    private optionList = [
        {
            value: TerminalInstallationEnumTypes.Status.NEW,
            label: i18n.t(`dictionary:${TerminalInstallationEnumTypes.Status.NEW}`),
            number: 1,
            img: TerminalInstalationStatusIcon.get(TerminalInstallationEnumTypes.Status.NEW)
        },
        {
            value: TerminalInstallationEnumTypes.Status.INSTALLATION_DATE_CONFIRMED,
            label: i18n.t(`dictionary:${TerminalInstallationEnumTypes.Status.INSTALLATION_DATE_CONFIRMED}`),
            number: 2,
            img: TerminalInstalationStatusIcon.get(TerminalInstallationEnumTypes.Status.INSTALLATION_DATE_CONFIRMED)
        },
        {
            value: TerminalInstallationEnumTypes.Status.INSTALLATION_FINISHED,
            label: i18n.t(`dictionary:${TerminalInstallationEnumTypes.Status.INSTALLATION_FINISHED}`),
            number: 3,
            img: TerminalInstalationStatusIcon.get(TerminalInstallationEnumTypes.Status.INSTALLATION_FINISHED)
        },
        {
            value: TerminalInstallationEnumTypes.Status.INSTALLATION_CONFIRMED,
            label: i18n.t(`dictionary:${TerminalInstallationEnumTypes.Status.INSTALLATION_CONFIRMED}`),
            number: 4,
            img: TerminalInstalationStatusIcon.get(TerminalInstallationEnumTypes.Status.INSTALLATION_CONFIRMED)
        },
        {
            value: TerminalInstallationEnumTypes.Status.CANCELLED,
            label: i18n.t(`dictionary:${TerminalInstallationEnumTypes.Status.CANCELLED}`),
            number: 5,
            img: TerminalInstalationStatusIcon.get(TerminalInstallationEnumTypes.Status.CANCELLED)
        },
    ];

    private columns = [
        {
            id: 'orderStatus',
            accessor: 'status',
            Header: 'hiddenHeader',
            className: 'cell',
            maxWidth: 120,
            Cell: this.statusCell,
            Filter: this.statusFilter
        },
        {
            Header: 'hiddenHeader',
            id: 'orderNumber',
            accessor: 'orderNumber',
            className: 'cell copyable',
            maxWidth: 95,
            Cell: props => Cell.CutTextCell(props, this.props.copiedToClipboard),
            Filter: this.noOrderFilter
        },
        {
            Header: 'hiddenHeader',
            id: 'sellerProposalNumber',
            accessor: 'sellerProposalNumber',
            className: 'cell copyable',
            maxWidth: 95,
            Cell: props => Cell.CutTextCell(props, this.props.copiedToClipboard),
            Filter: this.noSellerProposalFilter
        },
        {
            Header: 'hiddenHeader',
            id: 'carManufacturerOrModel',
            accessor: 'carManufacturer',
            className: 'cell copyable',
            Cell: props => Cell.carManufacturerOrModelCell(props, this.props.copiedToClipboard),
            Filter: this.carManufacturerOrModelFilter
        },
        {
            Header: 'hiddenHeader',
            id: 'address',
            accessor: 'plannedAddress',
            className: 'cell copyable',
            Cell: props => Cell.CutAddress(props, this.props.copiedToClipboard),
            Filter: this.addressFilter
        },
        {
            Header: 'hiddenHeader',
            id: 'vin',
            accessor: 'vin',
            Filter: this.vinFilter,
            className: 'cell copyable',
            Cell: props => Cell.CutTextCell(props, this.props.copiedToClipboard)
        },
        {
            Header: 'hiddenHeader',
            id: 'technicianFirstOrLastName',
            className: 'cell copyable',
            Cell: props => Cell.GetTechnicianFullName(props, this.props.copiedToClipboard),
            Filter: this.technicianFilter
        },
        {
            Header: 'hiddenHeader',
            id: 'orderReceivalDate',
            accessor: 'orderReceivalDate',
            className: 'cell copyable',
            Cell: props => this.cutDataTextCall(props, this.props.copiedToClipboard),
            Filter: this.orderReceivalDateFilter
        },
        {
            Header: 'hiddenHeader',
            id: 'plannedInstallationDate',
            accessor: 'plannedInstallationDate',
            className: 'cell copyable',
            Cell: props => this.cutDataTextCall(props, this.props.copiedToClipboard),
            Filter: this.plannedInstallationDateFilter
        },
        {
            Header: 'hiddenHeader',
            id: 'installationDate',
            accessor: 'installationDate',
            className: 'cell copyable',
            Cell: props => this.cutDataTextCall(props, this.props.copiedToClipboard),
            Filter: this.installationDateFilter
        },
        {
            expander: true,
            Header: 'hiddenHeader',
            className: 'cell',
            width: 65,
            Expander: Cell.Expander
        }
    ];
}

function mapDispatchToProps(dispatch: any): ConnectedDispatch {
    return {
        getTerminalInstallationOrders: (queryParams?: URLSearchParams, filterQuery?: boolean) => dispatch(TerminalInstallationModule.Actions.getTerminalInstallationOrders(queryParams, filterQuery)),
        getTerminalInstallationOrderHistory: (index: number) => dispatch(TerminalInstallationModule.Actions.getTerminalInstallationOrderHistory(index)),
        setTerminalInstallationOrderHistoryList: (list: Array<any>) => dispatch(TerminalInstallationModule.Actions.setTerminalInstallationOrderHistory(list)),
        setActive: (id: number) => dispatch(TerminalInstallationModule.Actions.setActive(id)),
        setStatusHistoryLoader: (status: TerminalInstallationModule.TerminalInstallationEnumTypes.HistoryRequestStatus) => dispatch(TerminalInstallationModule.Actions.setStatusHistoryLoader(status)),
        copiedToClipboard: (text: string) => dispatch(ErrorActions.setNewsForMoment({
            type: ErrorEnumType.NewsType.SUCCESS,
            message: i18n.t('forms:copied') + ': ' + text
        })),
        addNote: (index: number, note: string) => dispatch(TerminalInstallationModule.Actions.addNote(index, note)),
        getTerminalNotes: (index: number) => dispatch(TerminalInstallationModule.Actions.getTerminalInstallationNotes(index)),
        setInfinityTableLoading: (value: boolean) => dispatch(InfinityTableModule.Actions.setInfinityTableLoading(value)),
        setCurrentContractVin: (currentVin) => dispatch(ContractModule.Actions.setCurrentContractVin(currentVin))
    };
}

function mapStateToProps(state: RootState): ConnectedProps {
    return {
        terminalInstallationOrderList: state.terminalInstallationStore.terminalInstallationOrderList,
        terminalInstallationTotalCount: state.terminalInstallationStore.terminalInstallationTotalCount,
        terminalInstallationOrderActive: state.terminalInstallationStore.terminalInstallationOrderActive,
        terminalInstallationOrderHistoryList: state.terminalInstallationStore.terminalInstallationOrderHistoryList,
        terminalInstallationNotesList: state.terminalInstallationStore.terminalInstallationNotesList,
        historyLoader: state.terminalInstallationStore.historyLoader,
        historyComment: TerminalInstallationSelectors.getTerminalInstallationHistoryComments(state),
        selectedContractElementId: TerminalInstallationSelectors.getSelectedContractElementId(state), //używane jeśli bym chciał zaznaczyć wiersz z obiektem o ID wybranego uprzednio numeru umowy
        selectedContractVin: state.contractStore.currentVin
    };
}

export default withTranslation(['forms', 'tables', 'dictionary'])(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(TerminalInstallationList) as React.ComponentType<any>
);



// WEBPACK FOOTER //
// ./src/components/TerminalInstallation/TerminalInstallationList.tsx